import { logoutUser, setAuthState } from 'store/slices/auth/slice';
import { clearLaunchpadSplashSeen } from 'utils/launchpadSplash';

import type { Middleware } from '@reduxjs/toolkit';

const launchpadSplashMiddleware: Middleware = () => (next) => (action) => {
  if (logoutUser.match(action)) {
    clearLaunchpadSplashSeen();
  }

  if (setAuthState.match(action) && action.payload.refreshToken) {
    clearLaunchpadSplashSeen();
  }

  return next(action);
};

export default launchpadSplashMiddleware;
